import './InformationWidget.css';
import {useMediaQuery} from "react-responsive";
import {useEffect} from "react";

export default function InformationWidget({ text, height }) {
    const isMobile = useMediaQuery({ maxWidth: 992 });
    useEffect(()=>{

    })

    return (
        <div
            className="information-widget"
            style={{height:height ? { height } : undefined}}
        >

            <div className="information-widget-message-box">
                <span className="information-widget-message-text">
                    {text}
                </span>
            </div>
            <div className="information-widget-icon"></div>
        </div>
    );
}
